var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignupBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 384,
    r: 47.5,
    stroke: "#1F242F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 384,
    r: 95.5,
    stroke: "#1F242F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 384,
    r: 143.5,
    stroke: "#1F242F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 384,
    r: 191.5,
    stroke: "#1F242F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 384,
    r: 239.5,
    stroke: "#1F242F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 384,
    r: 287.5,
    stroke: "#1F242F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 384,
    r: 335.5,
    stroke: "#1F242F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 384,
    r: 383.5,
    stroke: "#1F242F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupBg);
export default __webpack_public_path__ + "static/media/signupBg.3dd0b12da5b7cf050150ae06de7b0408.svg";
export { ForwardRef as ReactComponent };